import { createModel } from "@rematch/core";

import type { RootModel } from ".";
import { MetricsTypes } from "../types/metrics.types";

export interface MetricsStoreProps {
   overallMetrics:  MetricsTypes.DashboardOverallCount
}

export const metricsInitialState = {
    overallMetrics: {} as MetricsTypes.DashboardOverallCount,
    latestMobileVersion: {} as MetricsTypes.LatestMobileVersion
};

export const metrics = createModel<RootModel>()({
    state: metricsInitialState,
    reducers: {
        boot: (store) => {
            store = metricsInitialState;
        },
        setMetrics: (store, updatedMetrics: MetricsTypes.DashboardOverallCount) => {
            store.overallMetrics = updatedMetrics;
        },
        setLatestMobileVersion: (store, updatedLatestMobileVersion: MetricsTypes.LatestMobileVersion) => {
            store.latestMobileVersion = updatedLatestMobileVersion;
        }
    },
});